import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import VueTheMasck from 'vue-the-mask';
import PrimeVue from 'primevue/config';
import Message from 'primevue/message';
import Dialog from 'primevue/dialog';
import Password from 'primevue/password';
import Divider from 'primevue/divider';
import CascadeSelect from "primevue/cascadeselect";
import Dropdown from 'primevue/dropdown';
import Tooltip from 'primevue/tooltip';
import { limparCampo } from "@/domain/limpaCaracteresEspeciais";

// importando estilos css
import './assets/css/formularioAnexo.css';
import './assets/css/formularioCasado.css';
import './assets/css/formularioEndereco.css';
import './assets/css/formularioPadrao.css';
import './assets/css/formularioToken.css';
import './assets/css/modalAlterarSenha.css';
import './assets/css/modalComprovante.css';
import './assets/css/modalImagens.css';
import './assets/css/paginaNaoEncontrada.css';
import './assets/css/styleResponsivo.css';
import './assets/css/btnVolta.css';
import './assets/css/fonts.css';
import './assets/css/barraPassos.css';
import './assets/css/botaoPadrao.css';
import './assets/css/padraoCssProjeto.css';

// Icones primeVue
import 'primeicons/primeicons.css';

// Css PrimeVue
import "primevue/resources/themes/lara-light-indigo/theme.css";
import "primevue/resources/primevue.min.css";

createApp(App)
    .use(router)
    .use(VueTheMasck)
    .use(PrimeVue)
    .use(limparCampo)
    .component('Message', Message)
    .component('Dialog', Dialog)
    .component('Password', Password)
    .component('Divider', Divider)
    .component('CascadeSelect', CascadeSelect)
    .component('Dropdown', Dropdown)
    .directive('Tooltip', Tooltip)
    .mount('#app');